export enum Mode {
  FINISHED = "FINISHED",
  PREVIOUS = "PREVIOUS",
  ROLE_AVERAGE = "ROLE_AVERAGE",
  TEAM_AVERAGE = "TEAM_AVERAGE",
}